module.exports = __webpack_public_path__ + "img/marinaLoshak@2x.040654ba.jpg";